<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>My Profile</mat-card-title>
        <mat-card-subtitle style="margin-top: 5px;">*You can only update First name, Last Name & Alternate Mobile Number</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content style="margin-top: 15px;">
        <app-banner-alert></app-banner-alert>
        <form [formGroup]="userProfileForm" (ngSubmit)="onSubmit()" class="user-form">
            <div class="form-row">
                <mat-form-field appearance="outline" style="width: 33%;">
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName="firstName" />
                    <mat-error *ngIf="userProfileForm.get('firstName')?.hasError('required') && userProfileForm.get('firstName')?.touched">First Name is required</mat-error>
                    <mat-error *ngIf="userProfileForm.get('firstName')?.hasError('pattern') && userProfileForm.get('firstName')?.touched">First Name is invalid</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 33%;">
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="lastName" />
                    <mat-error *ngIf="userProfileForm.get('lastName')?.hasError('pattern') && userProfileForm.get('lastName')?.touched">Last Name is invalid</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 33%;">
                    <mat-label>Mobile Number</mat-label>
                    <input [maxLength]="10" matInput formControlName="mobileNumber" [disabled]="true" />
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" style="width: 50%;">
                    <mat-label>Email Address</mat-label>
                    <input matInput formControlName="emailAddress"/>
                    <mat-error *ngIf="userProfileForm.get('emailAddress')?.hasError('email') && userProfileForm.get('emailAddress')?.touched">Invalid Email Address</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 50%;">
                    <mat-label>Alternate Mobile No</mat-label>
                    <input [maxLength]="10" matInput formControlName="alternateMobileNumber" />
                    <mat-error *ngIf="userProfileForm.get('alternateMobileNumber')?.hasError('pattern') && userProfileForm.get('alternateMobileNumber')?.touched">Invalid Alternate Mobile No</mat-error>
                </mat-form-field>
            </div>

            <div class="form-actions">
                <button mat-flat-button color="primary" type="submit">Save</button>
                <button mat-button type="button" (click)="backToHome()">Back</button>
            </div>

            <div class="deactivation-panel" *ngIf="canDeactivateAccount">
                <div class="deactivation-copy">
                    <h3 class="deactivation-title">Deactivate Account</h3>
                    <p class="deactivation-message">
                        This will close your active location allocations and disable your resident login. Use this only if you no longer need access to this account.
                    </p>
                </div>
                <button
                    mat-stroked-button
                    color="warn"
                    type="button"
                    (click)="openDeactivateAccountDialog()"
                    [disabled]="isDeactivatingAccount">
                    Deactivate My Account
                </button>
            </div>
        </form>
    </mat-card-content>
</mat-card>
